import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
	sectionContainer: {
		display: "flex",
		flexDirection: "row",
		[theme.breakpoints.down("xl")]: {
			flexDirection: "column",
		},
		"&.sectionContainerModal": {
			flexDirection: "column",
		},
	},
	metricsInfo: {
		display: "flex",
		width: "65%",
		[theme.breakpoints.down("xl")]: {
			width: "100%",
		},
		"&.metricsInfoModal": {
			width: "100%",
		},
	},
	sectionDivider: {
		width: "2px",
		background: "#E0E0E0",
		[theme.breakpoints.down("xl")]: {
			width: "96%",
			height: "2px",
			margin: "10px 24px !important",
		},
		"&.sectionDividerModal": {
			width: "93%",
			height: "2px",
			margin: "10px 24px",
		},
	},
}));
